import React, { useId } from 'react'

/**
 * Native <select>, styled to match other form controls.
 *
 * Pass `options` as `[{ value, label }]`, *or* render `<option>` children directly.
 */
export function Select({
  label,
  value,
  onChange,
  options,
  disabled = false,
  required = false,
  error,
  id,
  className = '',
  children,
  ...rest
}) {
  const generatedId = useId()
  const inputId = id || generatedId
  const errorId = `${inputId}-error`
  const hasError = Boolean(error)
  return (
    <div className={['field', className].filter(Boolean).join(' ')}>
      {label ? (
        <label
          className="label"
          htmlFor={inputId}
          data-required={required || undefined}
        >
          {label}
        </label>
      ) : null}
      <select
        id={inputId}
        className="select"
        value={value}
        onChange={onChange}
        disabled={disabled}
        aria-required={required || undefined}
        aria-invalid={hasError || undefined}
        aria-describedby={hasError ? errorId : undefined}
        {...rest}
      >
        {options
          ? options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))
          : children}
      </select>
      {hasError ? (
        <span id={errorId} role="status" className="field-error">
          {error}
        </span>
      ) : null}
    </div>
  )
}
